import {
  DeploymentAPIDomains,
  DeploymentDAGExplorerDomains,
  DeploymentMetagraphIds
} from '@dor/infra';
import { EnvironmentContext } from '@dor/lib';

export const MetagraphIndexerBaseUrl = `https://${
  DeploymentAPIDomains[EnvironmentContext.stage]
}`;

export const DeploymentDAGExplorerBaseUrl = `https://${
  DeploymentDAGExplorerDomains[EnvironmentContext.stage]
}`;

export const DeploymentMetagraphId =
  DeploymentMetagraphIds[EnvironmentContext.stage];
